import HomePage from "./Home.page";

export default HomePage;
